export type SubscriptionFeature = {
  name: string
  plusAvailability?: boolean
  platinumValue?: string
  basicAvailability?: boolean
  basicValue?: string
  plusValue?: string
  icon: string
}

export type FeatureTexts = {
  advancedStatistics: string
  recommendations: string
  improvedDrop: string
  moreGigi: string
  moreGamed: string
  freeCase: string
  updateProgress: string
}

export enum SubscriptionLevel {
  'PLUS' = 1,
  'PLATINUM' = 2,
}

// export type FeatureTexts = {
//   extra_update_bonus: string
//   free_reroll: string
//   free_gamed_box: string
//   games_owned: string
//   items_owned: string
//   total_account_value: string
//   total_playtime: string
//   daily_playtime: string
//   account_age: string
//   registration_date: string
//   inventory_price: string
//   favorite_genre: string
//   recommendations: string
// }
